import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { borderRadius } from 'styled-system';

import RectShape from './RectShape';

const UnstyledRoundedRectShape = styled(RectShape)<any>`
  ${borderRadius};
`;

const RoundedRectShape = (props: ComponentProps<typeof UnstyledRoundedRectShape>) => (
  <UnstyledRoundedRectShape borderRadius="large" bg="sys.neutral.background.hover" {...props} />
);

export default RoundedRectShape;
